import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ChangeEmail from '../components/ChangeEmail';

const NewEmail = () => {
    return (
        <div>
            <Header />
            <ChangeEmail />
            <Footer />
        </div>
    );
};

export default NewEmail;
